module.exports = __webpack_public_path__ + "img/success.5ab9710a.png";